import { render, staticRenderFns } from "./QuotationsCreate.vue?vue&type=template&id=631b2fd2&"
import script from "./QuotationsCreate.vue?vue&type=script&lang=js&"
export * from "./QuotationsCreate.vue?vue&type=script&lang=js&"
import style0 from "./QuotationsCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports